import { get } from "lodash";
import * as React from "react";

const { Component } = React;


import { Button, FormGroup, Input, Label } from "reactstrap";
import * as AccountStore from "../account/AccountStore";
import { GetContext, UnsubscribeContext } from "../general/ApplicationContext";
import Loader from "../general/Loader";
import ManagedServiceInstance from "../managedServices/ManagedInstance";
import * as ManagedServiceStore from "../managedServices/ManagedServiceStore";
import { AzureManagedService, RenderAzureRow } from "../managedServices/services/Azure";
import { COVIDManagedService, RenderCOVIDRow } from "../managedServices/services/COVID";
import { DiscordManagedService, RenderDiscordRow } from "../managedServices/services/Discord";
import { LinkManagedService, RenderLinkRow } from "../managedServices/services/Link";
import { RenderSASAMSRow, SASAMSManagedService } from "../managedServices/services/SASAMS";
import { RenderScadsysRow, ScadsysManagedService } from "../managedServices/services/Scadsys";
import { RenderScadsysBiometricsRow, ScadsysBiometricsManagedService } from "../managedServices/services/ScadsysBiometrics";
import { RenderSendGridRow, SendGridManagedService } from "../managedServices/services/SendGrid";
import { RenderStoreRow, StoreManagedService } from "../managedServices/services/Store";

interface OrganizationManagedServicesState {
    organization: string;

    showModal: boolean;
    currentUser: any;

    isLoading: boolean;

    managedServices: Array<any>;

    currentManagedService: any;
}

interface OrganizationManagedServicesProps {}

let contextSubscriptionId = "";

export var ConfigFormField = (key, name, state, handleChange) => {
    return (
        <FormGroup>
            <Label for={key}>{name}</Label>
            <Input id={key} type="text" value={get(state, key)} onChange={handleChange(key)}></Input>
        </FormGroup>
    );
};

const defaultServices = {
    managedServices: [],
    currentManagedService: null,
};

export default class OrganizationManagedServices extends Component<OrganizationManagedServicesProps, OrganizationManagedServicesState> {
    constructor(props) {
        super(props);
        this.state = {
            organization: "",
            showModal: false,
            currentUser: undefined,
            isLoading: true,
            ...defaultServices,
        };
    }

    componentDidMount() {
        contextSubscriptionId = GetContext((context) => {
            this.setState({ organization: context.currentOrganization.id, ...defaultServices }, () => {
                AccountStore.GetCurrentLoggedInUser().then((user) => {
                    this.setState({ currentUser: user });
                });

                this.listManagedServices();
            });
        });
    }

    listManagedServices = () => {
        ManagedServiceStore.ListManagedServices(this.state.organization).then((response) => {
            this.setState({ managedServices: response.data, isLoading: false, currentManagedService: null });
        });
    };

    componentWillUnmount() {
        UnsubscribeContext(contextSubscriptionId);
    }

    showManagedServiceInstace = (service) => () => {
        this.setState({ currentManagedService: service });
    };

    render() {
        return (
            <div>
                <div>
                    {this.state.isLoading && <Loader></Loader>}
                    {!this.state.isLoading && (
                        <>
                            <div className="row">
                                {this.state.managedServices.filter((m) => m.type == 1).length == 0 && (
                                    <>
                                        <SASAMSManagedService organizationId={this.state.organization} onDone={() => this.listManagedServices()}></SASAMSManagedService>
                                    </>
                                )}
                                {this.state.managedServices.filter((m) => m.type == 2).length == 0 && (
                                    <>
                                        <ScadsysManagedService organizationId={this.state.organization} onDone={() => this.listManagedServices()}></ScadsysManagedService>
                                    </>
                                )}
                                {this.state.managedServices.filter((m) => m.type == 4).length == 0 && (
                                    <>
                                        <ScadsysBiometricsManagedService organizationId={this.state.organization} onDone={() => this.listManagedServices()}></ScadsysBiometricsManagedService>
                                    </>
                                )}
                                <>
                                    <StoreManagedService organizationId={this.state.organization} onDone={() => this.listManagedServices()}></StoreManagedService>
                                </>
                                <>
                                    <AzureManagedService organizationId={this.state.organization} onDone={() => this.listManagedServices()}></AzureManagedService>
                                </>
                                <>
                                    <COVIDManagedService organizationId={this.state.organization} onDone={() => this.listManagedServices()}></COVIDManagedService>
                                </>
                                <>
                                    <SendGridManagedService organizationId={this.state.organization} onDone={() => this.listManagedServices()}></SendGridManagedService>
                                </>
                                <>
                                    <LinkManagedService organizationId={this.state.organization} onDone={() => this.listManagedServices()}></LinkManagedService>
                                </>
                                <>
                                    <DiscordManagedService organizationId={this.state.organization} onDone={() => this.listManagedServices()}></DiscordManagedService>
                                </>
                            </div>

                            {!this.state.currentManagedService && this.state.managedServices.length > 0 && (
                                <>
                                    <div className="mt-2">Configured Services</div>
                                    <div>
                                        <div className="row">
                                            <table className="table">
                                                <thead>
                                                    <tr>
                                                        <td>Service Type</td>
                                                        <td></td>
                                                        <td></td>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {this.state.managedServices.map((service, i) => (
                                                        <tr key={i}>
                                                            <td>{ManagedServiceStore.TypeName(service.type)}</td>
                                                            {service.type == 0 && RenderLinkRow(service.configuration)}
                                                            {service.type == 1 && RenderSASAMSRow(service.configuration)}
                                                            {service.type == 2 && RenderScadsysRow(service.configuration)}
                                                            {service.type == 3 && RenderStoreRow(service.configuration)}
                                                            {service.type == 4 && RenderScadsysBiometricsRow(service.configuration)}
                                                            {service.type == 5 && RenderAzureRow(service.configuration)}
                                                            {service.type == 6 && RenderCOVIDRow(service.configuration)}
                                                            {service.type == 7 && RenderSendGridRow(service.configuration)}
                                                            {service.type == 8 && RenderDiscordRow(service.configuration)}
                                                            <td>
                                                                <Button color="primary" onClick={this.showManagedServiceInstace(service)}>
                                                                    View
                                                                </Button>
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </>
                            )}
                            {this.state.currentManagedService && (
                                <>
                                    <Button color="link" onClick={() => this.setState({ currentManagedService: null })}>
                                        Back
                                    </Button>
                                    <ManagedServiceInstance managedService={this.state.currentManagedService} onChange={this.listManagedServices}></ManagedServiceInstance>
                                </>
                            )}
                        </>
                    )}
                </div>
            </div>
        );
    }
}
